__turbopack_context__.v({
  "action": "EmptyState-module-scss-module__uTGtSa__action",
  "align-center": "EmptyState-module-scss-module__uTGtSa__align-center",
  "align-left": "EmptyState-module-scss-module__uTGtSa__align-left",
  "description": "EmptyState-module-scss-module__uTGtSa__description",
  "icon": "EmptyState-module-scss-module__uTGtSa__icon",
  "inner": "EmptyState-module-scss-module__uTGtSa__inner",
  "root": "EmptyState-module-scss-module__uTGtSa__root",
  "size-lg": "EmptyState-module-scss-module__uTGtSa__size-lg",
  "size-sm": "EmptyState-module-scss-module__uTGtSa__size-sm",
  "text": "EmptyState-module-scss-module__uTGtSa__text",
  "title": "EmptyState-module-scss-module__uTGtSa__title",
  "tone-brand": "EmptyState-module-scss-module__uTGtSa__tone-brand",
  "tone-danger": "EmptyState-module-scss-module__uTGtSa__tone-danger",
  "tone-muted": "EmptyState-module-scss-module__uTGtSa__tone-muted",
  "tone-neutral": "EmptyState-module-scss-module__uTGtSa__tone-neutral",
});
